module.exports = __webpack_public_path__ + "img/map-img.6d586780.jpg";